import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import { APP_MENUS } from '../../constants';
import { useNavigate, useLocation } from 'react-router-dom';
import { memo, useState, useEffect } from 'react';

const BottomNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedMenu, setSelectedMenu] = useState(location.pathname);

  useEffect(() => {
    setSelectedMenu(location.pathname);
  }, [location.pathname]);

  const handleNavigate = (path: string) => {
    setSelectedMenu(path);
    navigate(path);
  };

  return (
    <BottomNavigation
      value={selectedMenu}
      showLabels
      sx={{
        bottom: 0,
        bgcolor: 'primary.main',
        height: 'auto',
        mt: 'auto',
        px: 1.5,
        py: 0.5,
      }}
      className="position-sticky"
    >
      {APP_MENUS?.map(
        ({ label, path, icon: IconComponent, disabled = false }) => {
          return (
            <BottomNavigationAction
              key={path}
              label={label}
              icon={
                <IconComponent
                  sx={{
                    fontSize: 28,
                  }}
                />
              }
              sx={{
                position: 'relative',
                color: 'common.white',
                p: 1.5,
                gap: 0.5,
                borderRadius: 1,
                // For Selected Menu
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: 6,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: selectedMenu === path ? '15px' : '0',
                  height: '3px',
                  bgcolor: 'common.white',
                  transition: 'width 0.3s ease-in-out',
                },
              }}
              disabled={disabled}
              onClick={() => handleNavigate(path)}
            />
          );
        }
      )}
    </BottomNavigation>
  );
};

export default memo(BottomNavbar);
